import { render } from "./dashboard-svg.vue?vue&type=template&id=d1c8bc04"
const script = {}

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__